// Star Rewards quiz icon set: our own drawn pictures, no stock emoji.
// Each icon is { id, en, da, svg }, where svg is the inside of a 120x120
// viewBox. Draw one with quizIconSvg(id) - the outline style is applied here,
// once, so every icon looks the same.
//
// Questions carry up to 3 ids in question_data.icons (history, science and
// spelling). The quiz shows them after the kid answers (QuizIcons in app.jsx).
// The Worker keeps its own copy of the ids in worker/src/quiz-icons.js - add a
// new icon there too (CI checks the two lists match).
import { SCIENCE_ICONS } from "./science.js";
import { HISTORY_ICONS } from "./history.js";
import { EVERYDAY_ICONS } from "./everyday.js";
import { MORE_ICONS } from "./more.js";

export const QUIZ_ICONS = [...SCIENCE_ICONS, ...HISTORY_ICONS, ...EVERYDAY_ICONS, ...MORE_ICONS];
export const QUIZ_ICON_IDS = QUIZ_ICONS.map(i => i.id);
const BY_ID = new Map(QUIZ_ICONS.map(i => [i.id, i]));

// Shown when a question has no matching icon.
export const SUBJECT_FALLBACK_ICON = {
  science: "flask", history: "scroll", geography: "globe", spelling: "abc", math: "abacus",
};

export const QUIZ_ICON_INK = "#3B3355";

export function quizIcon(id) { return BY_ID.get(id) || null; }

export function quizIconSvg(id, size = 120) {
  const icon = BY_ID.get(id);
  if (!icon) return "";
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 120 120" fill="none" stroke="${QUIZ_ICON_INK}" stroke-width="4" stroke-linejoin="round" stroke-linecap="round" role="img" aria-label="${icon.en}">${icon.svg}</svg>`;
}
